/*******************************************
* Screen reader only helper.
*******************************************/
/*
      |\      _,,,---,,_
ZZZzz /,`.-'`'    -.  ;-;;,_
     |,4-  ) )-,_. ,\ (  `'-'
    '---''(_/--'  `-'\_)

	Important! Generated file from keys in ace-betting-bet-button.get-names.ts 
*/
:host {
  border-radius: var(--ace-semantic-foundation-radius-xs);
  box-sizing: border-box;
  display: inline-block;
  height: 100%;
  overflow: hidden;
  position: relative;
}
:host * {
  box-sizing: border-box;
}

:host([show-sort-indicator])::after {
  background: var(--ace-color-brand-verticals--sports);
  bottom: 0;
  content: "";
  display: block;
  height: 0.1875rem;
  position: absolute;
  width: 100%;
}

:host([selected])::after {
  background: var(--ace-color-semantic-bet-button-sort-indicator);
}

:host([has-tendency]) {
  overflow: visible;
}

:host([full-width=true]) {
  width: 100%;
}

.ace-betting-bet-button {
  margin: 0;
  padding: 0;
  border: 0;
  font-size: 100%;
  vertical-align: baseline;
  background: unset;
  font: inherit;
  align-items: center;
  background-color: var(--ace-color-surface-solid--200);
  border: 0;
  border-radius: var(--ace-semantic-foundation-radius-xs);
  display: flex;
  height: 100%;
  justify-content: center;
  overflow: hidden;
  padding: 0;
  position: relative;
  /* States */
}
.ace-betting-bet-button:not(:disabled):hover {
  border-color: var(--ace-color-semantic-toggle-button-border-colour-hover);
}
.ace-betting-bet-button:not(:disabled):hover .ace-betting-bet-button__odd,
.ace-betting-bet-button:not(:disabled):hover .ace-betting-bet-button__label {
  border-color: var(--ace-color-semantic-toggle-button-border-colour-hover);
}
.ace-betting-bet-button:focus-visible {
  outline: 0.125rem solid var(--ace-color-borders--focus);
  outline-offset: 0.125rem;
  z-index: 2;
}
.ace-betting-bet-button__label {
  color: var(--ace-color-text-neutral--secondary);
  font-family: var(--ace-type-font-family-text);
  font-size: var(--ace-semantic-content-containers-sports-item-label-font-size);
  font-weight: var(--ace-type-font-weight-button-subtle);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-semantic-content-containers-sports-item-label-line-height);
  overflow: hidden;
}
.ace-betting-bet-button__label span {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  -webkit-box-orient: vertical;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  overflow-wrap: break-word;
  white-space: normal;
}
.ace-betting-bet-button__odd {
  color: var(--ace-color-text-neutral--interactive);
  display: flex;
  font-family: var(--ace-semantic-buttons-sports-buttons-font-family);
  font-size: var(--ace-type-font-size-text-small);
  font-weight: var(--ace-type-font-weight-button);
  letter-spacing: var(--ace-type-letter-spacing-text-small);
  line-height: var(--ace-type-line-height-text-x-small);
}
.ace-betting-bet-button__odd__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  flex: 1;
  min-width: 0;
  width: 0;
}
.ace-betting-bet-button__locked-icon {
  margin: 0 auto;
}
.ace-betting-bet-button__indicator-up {
  animation: blink-odd-indicator 3s ease-in-out;
  position: absolute;
  right: 0;
  top: 0;
}
.ace-betting-bet-button__indicator-down {
  animation: blink-odd-indicator 3s ease-in-out;
  bottom: 0;
  left: 0;
  position: absolute;
}
.ace-betting-bet-button:not(:disabled):hover {
  cursor: pointer;
}
.ace-betting-bet-button--full-width {
  width: 100%;
}
.ace-betting-bet-button--vertical-layout {
  border: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  flex-direction: column;
  gap: 0.125rem;
  height: var(--ace-semantic-buttons-sports-buttons-height);
  padding: 0 var(--ace-primitive-spacing-xx-tight);
}
.ace-betting-bet-button--vertical-layout:not(.ace-betting-bet-button--full-width) {
  min-width: 3rem;
}
.ace-betting-bet-button--vertical-layout .ace-betting-bet-button__label,
.ace-betting-bet-button--vertical-layout .ace-betting-bet-button__odd {
  width: 100%;
}
.ace-betting-bet-button--horizontal-layout {
  flex-direction: row;
  justify-content: space-between;
  min-height: 2.75rem;
}
.ace-betting-bet-button--horizontal-layout:not(.ace-betting-bet-button--full-width) {
  min-width: 4.5rem;
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__label,
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__odd {
  align-items: center;
  display: flex;
  height: 100%;
  justify-content: center;
  min-height: 2.75rem;
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__label {
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  border-left: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  border-radius: var(--ace-semantic-foundation-radius-xs) 0 0 var(--ace-semantic-foundation-radius-xs);
  border-top: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  justify-content: flex-start;
  padding-left: var(--ace-primitive-spacing-xx-tight);
  text-align: left;
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__odd {
  border-bottom: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  border-radius: 0 var(--ace-semantic-foundation-radius-xs) var(--ace-semantic-foundation-radius-xs) 0;
  border-right: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  border-top: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  flex: 1;
  flex-shrink: 0;
  justify-content: flex-end;
  padding-left: var(--ace-primitive-spacing-xx-tight);
  padding-right: var(--ace-primitive-spacing-xx-tight);
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__odd__label {
  text-align: right;
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__odd:first-child {
  border: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
  border-radius: var(--ace-semantic-foundation-radius-xs);
}
.ace-betting-bet-button--horizontal-layout .ace-betting-bet-button__odd:first-child .ace-betting-bet-button__odd__label {
  text-align: center;
}
.ace-betting-bet-button--card-type {
  min-height: 2.5rem;
}
.ace-betting-bet-button--card-type .ace-betting-bet-button__label {
  flex: initial;
  justify-content: center;
  min-height: 2.5rem;
  padding: 0 var(--ace-primitive-spacing-x-tight);
}
.ace-betting-bet-button--card-type .ace-betting-bet-button__odd {
  flex: 1;
  justify-content: center;
  min-height: 2.5rem;
  position: relative;
}
.ace-betting-bet-button--card-type:not(.ace-betting-bet-button--selected) .ace-betting-bet-button__label {
  background-color: var(--ace-color-surface-solid--100);
}
.ace-betting-bet-button--card-type.ace-betting-bet-button--selected:not(.ace-betting-bet-button--inactive) .ace-betting-bet-button__label {
  overflow: visible;
  position: relative;
}
.ace-betting-bet-button--card-type.ace-betting-bet-button--selected:not(.ace-betting-bet-button--inactive) .ace-betting-bet-button__label span {
  overflow: hidden;
  position: relative;
  z-index: 1;
}
.ace-betting-bet-button--card-type.ace-betting-bet-button--selected:not(.ace-betting-bet-button--inactive) .ace-betting-bet-button__label::after {
  background-color: var(--ace-color-gradient-stops-gradient-dark-15);
  border-radius: var(--ace-semantic-foundation-radius-xs) 0 0 var(--ace-semantic-foundation-radius-xs);
  bottom: -1px;
  content: "";
  left: -1px;
  position: absolute;
  top: -1px;
  width: 100%;
}
.ace-betting-bet-button--card-type.ace-betting-bet-button--inactive {
  border-color: var(--ace-color-semantic-toggle-button-border-colour-default);
}
.ace-betting-bet-button--card-type.ace-betting-bet-button--inactive .ace-betting-bet-button__odd,
.ace-betting-bet-button--card-type.ace-betting-bet-button--inactive .ace-betting-bet-button__label {
  border-color: var(--ace-color-semantic-toggle-button-border-colour-default);
}
.ace-betting-bet-button--selected {
  background-color: var(--ace-color-semantic-bet-button-selected-button-color-default);
  border-color: var(--ace-color-semantic-bet-button-selected-button-color-default);
}
.ace-betting-bet-button--selected .ace-betting-bet-button__odd,
.ace-betting-bet-button--selected .ace-betting-bet-button__label {
  border-color: var(--ace-color-semantic-bet-button-selected-button-color-default);
}
.ace-betting-bet-button--selected .ace-betting-bet-button__label {
  color: var(--ace-color-text-neutral--secondary-uni-light);
}
.ace-betting-bet-button--selected .ace-betting-bet-button__odd {
  color: var(--ace-color-text-neutral--interactive-uni-light);
}
.ace-betting-bet-button--selected:hover:not(:disabled) {
  background-color: var(--ace-color-semantic-bet-button-selected-button-color-hover);
  border-color: var(--ace-color-semantic-bet-button-selected-button-color-hover);
}
.ace-betting-bet-button--selected:hover:not(:disabled) .ace-betting-bet-button__odd,
.ace-betting-bet-button--selected:hover:not(:disabled) .ace-betting-bet-button__label {
  border-color: var(--ace-color-semantic-bet-button-selected-button-color-hover);
}
.ace-betting-bet-button--locked {
  background-color: var(--ace-color-surface-solid--100);
  border: var(--ace-primitive-border-decorative) var(--ace-color-semantic-toggle-button-border-colour-default);
}
.ace-betting-bet-button--with-error {
  animation: blink-not-selectable 600ms steps(1, end) 2;
}
.ace-betting-bet-button--with-error .ace-betting-bet-button__odd,
.ace-betting-bet-button--with-error .ace-betting-bet-button__label {
  animation: blink-not-selectable 600ms steps(1, end) 2;
}
.ace-betting-bet-button--inactive {
  background-color: var(--ace-color-surface-solid--100);
  border-color: var(--ace-color-surface-solid--100);
  /* inactive + selected */
}
.ace-betting-bet-button--inactive .ace-betting-bet-button__odd,
.ace-betting-bet-button--inactive .ace-betting-bet-button__label {
  border-color: var(--ace-color-surface-solid--100);
}
.ace-betting-bet-button--inactive .ace-betting-bet-button__odd,
.ace-betting-bet-button--inactive .ace-betting-bet-button__label {
  color: var(--ace-color-text-neutral--secondary);
}
.ace-betting-bet-button--inactive.ace-betting-bet-button--selected {
  background-color: var(--ace-color-surface-solid--300);
  border-color: var(--ace-color-surface-solid--300);
}
.ace-betting-bet-button--inactive.ace-betting-bet-button--selected .ace-betting-bet-button__odd,
.ace-betting-bet-button--inactive.ace-betting-bet-button--selected .ace-betting-bet-button__label {
  border-color: var(--ace-color-surface-solid--300);
}
.ace-betting-bet-button--has-tendency {
  overflow: visible;
}
.ace-betting-bet-button--has-tendency .ace-betting-bet-button__odd__label {
  text-align: center;
}
.ace-betting-bet-button__tendency {
  left: 50%;
  position: absolute;
  top: -0.5rem;
  transform: translateX(-50%);
  z-index: 14;
}

@keyframes blink-not-selectable {
  0% {
    transition: ease-in-out 100ms;
  }
  50% {
    background-color: var(--ace-color-surface-semantic--highlight);
    border-color: var(--ace-color-surface-semantic--highlight);
    color: var(--ace-color-text-neutral--primary-uni-light);
    transition: ease-in-out 100ms;
  }
  100% {
    background-color: unset;
    color: unset;
    transition: ease-in-out 100ms;
  }
}
@keyframes blink-odd-indicator {
  0% {
    opacity: 0;
  }
  12.5% {
    opacity: 1;
  }
  25% {
    opacity: 1;
  }
  37.5% {
    opacity: 0;
  }
  50% {
    opacity: 0;
  }
  62.5% {
    opacity: 1;
  }
  75% {
    opacity: 1;
  }
  87.5% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}